import React, { useContext,useEffect} from 'react';
import './navbar.css';
import styled from 'styled-components';
import { AuthContext } from '../../auth';
import { Link,withRouter,Redirect} from 'react-router-dom';
import Parse from 'parse';
import swal from 'sweetalert';
// import {Redirect} from 'react-router-dom';


const StyledDiv = styled.div`
border-bottom: 0px solid #65cdf0;
`
const Styledh1 = styled.h1`
color: #65cdf0;
font-size: 26px;
padding-top: 9px;
margin:auto
`
const Styledspan = styled.span`
color: #65cdf0;
margin-left:4px;
`

const Styledbutton = styled.button`
background: #e9e9e9;
border: none;
padding: 10px;
border-radius: 12px;
color: #75cbfd;
`
// const StyledDiv2 = styled.div`
// float: right;
// margin-top: -32px;
// margin-right: 10px;
// font-size: 23px;
// `

const Navbar = (props) => {
    console.log(props.history,"naaavvvvbbbbarrr")
    const [logedinuser, setLogedinuser] = useContext(AuthContext);
    let data;
    const logout = () => {
        Parse.User.logOut().then(() => {
            var currentUser = Parse.User.current();  // this will now be null
            console.log(currentUser);
            setLogedinuser(null);
            props.history.replace("/");
        
        })
    }

    const handleCounsellorLogin=()=>{
        console.log("handle counsellor login");
        props.history.replace("/counsellor/login");
        
        
        
    }

   
    if (logedinuser == null) {
        data =
            (<div className="navhead">
                <Link to="/login" >Login</Link>
                <div>
                    <p>Dont have an account?</p>
                    <Link to="/register">Register here</Link>
                    <p className="cl" onClick={handleCounsellorLogin}>Counsellor Login</p>
                </div>
            </div>);


    } else {
       console.log("rasfsdasda");
        data =
            <div className="navhead">
                <i class="fas fa-user"></i><br />
                <strong>USER :</strong> {logedinuser}
                <br />
                <Styledbutton onClick={logout}>Log out</Styledbutton>
            </div>

    }

    

    const closeNav = () => {
        document.getElementById("mySidenav").style.width = "0";
    }

    const openNav = () => {
        document.getElementById("mySidenav").style.width = "250px";
    }

    const counsellor=(e)=>{
        
        if (logedinuser == null){
            e.preventDefault();
            swal("Oops!!","Login to continue");
        }
        else{
            
        }
    }

    return (
        <StyledDiv>

            <div id="mySidenav" className="sidenav" style={{zIndex:"1003"}}>
                <a href="javascript:void(0)" className="closebtn" onClick={closeNav}>&times;</a>

                {data}
                <div className="navcontent">

                    <Link to="/"><i className="fas fa-columns"></i>     DASHBOARD</Link>
                    <Link to="/educationexplore"><i className="fas fa-book-open"></i>     EDUCATION</Link>
                    <Link to="/stories"><i className="fas fa-users"></i>     STORIES</Link>
                    <Link to="/userprofile" onClick={counsellor}><i className="far fa-laugh"></i>     CHAT WITH COUNSELLOR</Link>
                    <Link to="/forum"><i className="fas fa-users"></i>     FAMILY SUPPORT FORUM</Link>
                    <Link to="/faq"><i className="far fa-comments"></i>     FAQs</Link>
                    <Link to="/rehabs"><i className="fas fa-map-marker-alt"></i>     REHABILATION CENTRES</Link>
                    <Link to="/queries"><i className="fas fa-question-circle"></i>     QUERIES</Link>
                    <Link to="/offline"><i className="fas fa-address-card"></i>     OFFLINE HELP </Link>
                    {/* {logedinuser? 
                    <Link to="/myoffline"><i className="far fa-laugh"></i>     MY APPOINTMENTS </Link>:null
                    } */}
                    <Link to="/resources"><i className="fas fa-info-circle"></i>     RESOURCES </Link>
                    {/* <Link to="/about"><i className="far fa-question-circle">  </i>     ABOUT US //coming soon</Link> */}
                </div>
            </div>
            <div className="" style={{position:"fixed",width:"100%",top:"0",background:"white",zIndex:"1002",borderBottom:"solid 2px #65cdf0"}}>
                <Styledspan onClick={openNav} >&#9776;</Styledspan>
                <Styledh1>{props.head}</Styledh1>
                {/* <StyledDiv2><Link to={`${props.link}`}><i className="backicon fas fa-arrow-left"></i></Link></StyledDiv2> */}
            </div>


        </StyledDiv>

    )
}


export default withRouter(Navbar);